import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import TablePreparation from "./components/table-preparation/TablePreparation";

export function PreparationReportsRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TablePreparation />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
